<script>
import {
  iButton,
  iButtonSizes,
  iButtonTypes,
  iButtonStyles,
  iFeaturedIcon,
  iFeaturedIconSizes,
  iKeyIcon,
  iKeyIconShape,
  iKeyIconStyle,
  iKeyIconType,
  iKeyIconSize,
} from '@inscribe/signal';

export const CustomerEmptyStateSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

export default {
  components: {
    iButton,
    iFeaturedIcon,
    iKeyIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: CustomerEmptyStateSize.MEDIUM,
    },
  },
  data() {
    return {
      CustomerEmptyStateSize,
      iButtonSizes,
      iButtonTypes,
      iButtonStyles,
      iFeaturedIconSizes,
      iKeyIconShape,
      iKeyIconStyle,
      iKeyIconType,
      iKeyIconSize,
    };
  },
  methods: {
    onButtonClick() {
      this.$emit('button-click');
    },
  },
};
</script>

<template>
  <div
    :class="{
      'i-p-16': size === CustomerEmptyStateSize.MEDIUM,
      'i-p-12': size === CustomerEmptyStateSize.SMALL,
    }"
    class="customer-empty-state d-flex flex-column align-items-center i-gap-8"
  >
    <i-key-icon
      v-if="icon"
      :icon="icon"
      :size="iKeyIconSize.XL"
      :shape="iKeyIconShape.SQUARE"
      :type="iKeyIconType.NEUTRAL"
      :icon-style="iKeyIconStyle.OUTLINE"
    />
    <div class="text d-flex flex-column align-items-center i-gap-1">
      <div class="i-text-neutral-120 i-text-heading-6">
        {{ title }}
      </div>
      <div class="i-text-neutral-110 i-text-body-2">{{ description }}</div>
    </div>
    <i-button
      v-if="showButton"
      text="Upload Documents"
      :size="iButtonSizes.MEDIUM"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.SOLID_LIGHT"
      @button-click="onButtonClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.customer-empty-state {
  background: $white-base;
}
</style>
